var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToasterWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 18.5167C16.5523 18.5167 17 18.2043 17 17.4154V10.2725C17 9.48353 16.5523 9.01672 16 9.01672C15.4477 9.01672 15 9.48353 15 10.2725V17.4154C15 18.2043 15.4477 18.5167 16 18.5167Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 22.0167C15 22.569 15.4455 23.0167 15.995 23.0167H16.005C16.5545 23.0167 17 22.569 17 22.0167C17 21.4644 16.5545 21.0167 16.005 21.0167H15.995C15.4455 21.0167 15 21.4644 15 22.0167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterWarning);
export default __webpack_public_path__ + "static/media/toaster-warning.3106536a15e668c4b99a0075291fa931.svg";
export { ForwardRef as ReactComponent };